import React from 'react';
import { InlineNotification } from 'carbon-components-react';
import {
  PricingSummary,
  PricingSummarySkeleton
} from 'components/PremiumWizard';
import { LivePrice } from 'redux/bydaMemberLookup/types';
import { formatLivePrice } from '../utils/formatLivePrice';

interface PriceStepProps {
  livePrice: LivePrice | null;
  isLivePriceLoading: boolean;
  livePriceError: string | null;
}

const PriceStep: React.FC<PriceStepProps> = ({
  livePrice,
  isLivePriceLoading,
  livePriceError
}) => {
  const formattedAmount = livePrice ? formatLivePrice(livePrice) : '—';

  const total = {
    label: 'Total payable',
    amount: formattedAmount
  };

  return (
    <div>
      <div className="byda-member-lookup__step-header">
        Get started with member outreach
      </div>

      <div className="byda-member-lookup__price-step-section byda-member-lookup__price-step-notification">
        <InlineNotification
          kind="info"
          title=""
          subtitle="Identify the utility members with infrastructure in your project area and access their contact details, so you can connect and coordinate directly with those affected by your work."
          lowContrast
          hideCloseButton
        />
      </div>

      {livePriceError && (
        <div className="byda-member-lookup__price-step-section">
          <InlineNotification
            kind="error"
            title="Unable to load price"
            subtitle={livePriceError}
            lowContrast
            hideCloseButton
          />
        </div>
      )}

      <div className="byda-member-lookup__price-step-section byda-member-lookup__price-step-how-it-works-card">
        <div className="byda-member-lookup__price-step-how-it-works-header">
          How it works
        </div>
        <ul className="byda-member-lookup__price-step-list">
          <li>
            <div className="byda-member-lookup__price-step-list-item-title">
              Define your project area
            </div>
            <div className="byda-member-lookup__price-step-list-item-description">
              Upload a file or draw your project area directly on the map.
            </div>
          </li>
          <li>
            <div className="byda-member-lookup__price-step-list-item-title">
              Identify affected members
            </div>
            <div className="byda-member-lookup__price-step-list-item-description">
              We&apos;ll identify utility members whose infrastructure overlaps
              with your project area.
            </div>
          </li>
          <li>
            <div className="byda-member-lookup__price-step-list-item-title">
              Download member details
            </div>
            <div className="byda-member-lookup__price-step-list-item-description">
              Download a CSV file containing member names, utility IDs and
              contact details so you can start your outreach.
            </div>
          </li>
        </ul>
      </div>

      <div className="byda-member-lookup__price-step-pricing-card">
        {isLivePriceLoading ? (
          <PricingSummarySkeleton
            lineItems={[]}
            totalLabel="Total payable"
            variant="default"
          />
        ) : (
          <PricingSummary lineItems={[]} total={total} />
        )}
      </div>
    </div>
  );
};

export default PriceStep;
